const createRecord = () => {
    storeCurrentRecord({
        markers: []
    })
}

const storeCurrentRecord = (record) => {
    localStorage.setItem("currentRecord", JSON.stringify(record))
}

const getCurrentRecord = () => {
    return JSON.parse(localStorage.getItem("currentRecord"))
}

export {
    createRecord,
    storeCurrentRecord,
    getCurrentRecord,
}